import { Check, ArrowLeft } from 'lucide-react';
import { PROFILE_STEPS, canOpenStep } from 'pages/Profile/helper';
import { useNavigate } from 'react-router-dom';
import { PORTAL_ROUTES } from 'utils/constants';
import { Button } from 'react-daisyui';

const STATUS_STYLE = {
  done: { circle: 'bg-success-50 text-success-600 border-2 border-success-500 sm:bg-success-500 sm:text-white', label: 'text-success-600 font-semibold' },
  active: { circle: 'bg-teamcare-blue text-white ring-4 ring-teamcare-blue/15', label: 'text-teamcare-blue font-bold' },
  open: { circle: 'bg-white text-teamcare-blue border-2 border-teamcare-blue', label: 'text-secondary-500 font-medium' },
  locked: { circle: 'bg-secondary-100 text-secondary-400 border-2 border-secondary-200', label: 'text-secondary-400 font-medium' },
};

const ACTIVE_MOBILE = 'max-sm:border-teamcare-blue';

const Stepper = ({ completion = {}, activeId, onStepClick }) => {
  const navigate = useNavigate();

  return (
    <div className="flex-shrink-0 relative flex items-center justify-center border-b border-gray-100 px-5 py-4 lg:px-7">
      <Button
        size="sm"
        variant="outline"
        onClick={() => navigate(PORTAL_ROUTES.PROFILE)}
        className="absolute left-5 lg:left-7 flex items-center gap-1.5 border-gray-200 text-secondary-600 hover:text-secondary-900 hover:border-gray-300 bg-white hover:bg-white"
      >
        <ArrowLeft size={14} />
        <span className="hidden lg:inline">All forms</span>
      </Button>

      <div className="flex w-4/5 max-w-[640px] items-start">
        {PROFILE_STEPS.map((step, i) => {
          const Icon = step.icon;
          const done = !!completion[step.id];
          const openable = canOpenStep(i, completion);
          const isActive = step.id === activeId;
          const status = done ? 'done' : isActive ? 'active' : openable ? 'open' : 'locked';
          const { circle } = STATUS_STYLE[status];
          const { label } = STATUS_STYLE[isActive ? 'active' : status];
          const clickable = openable || done;
          const connected = done || canOpenStep(i + 1, completion);

          return (
            <div key={step.id} className="relative flex flex-1 flex-col items-center">
              {i < PROFILE_STEPS.length - 1 && (
                <span className={`absolute left-1/2 top-4 z-0 h-[2.5px] w-full ${connected ? 'bg-success-500' : 'bg-secondary-200'}`} />
              )}
              <button
                type="button"
                onClick={() => clickable && onStepClick(step)}
                disabled={!clickable}
                className={`relative z-[1] flex h-[34px] w-[34px] items-center justify-center rounded-full text-sm font-bold transition-all ${clickable ? 'cursor-pointer' : 'cursor-default'} ${circle} ${isActive ? ACTIVE_MOBILE : ''}`}
              >
                <Icon size={16} className="sm:hidden" />
                {done ? (
                  <Check size={15} strokeWidth={3.2} className="hidden sm:block" />
                ) : (
                  <span className="hidden sm:block">{i + 1}</span>
                )}
                {done && (
                  <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-success-500 ring-2 ring-white sm:hidden">
                    <Check size={10} strokeWidth={4} className="text-white" />
                  </span>
                )}
              </button>
              <span className={`mt-[7px] hidden whitespace-nowrap text-center text-[11.5px] sm:block ${label}`}>{step.navLabel}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
